import React from 'react';

export const OpenFilter = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
    <path fillRule='evenodd' clipRule='evenodd' d='M10.125 0.5H7.875V8.375L0 8.375V10.625H7.875V18.5H10.125V10.625H18V8.375L10.125 8.375V0.5Z' fill='black' />
  </svg>
);
